module.exports = __webpack_public_path__ + "img/nothingToShow.8363c49f.svg";